import { render, staticRenderFns } from "./ReferralProgramExtra.vue?vue&type=template&id=34ec9edb&"
import script from "./ReferralProgramExtra.vue?vue&type=script&lang=js&"
export * from "./ReferralProgramExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports